import * as React from 'react';
import { object as PropObject } from 'prop-types';
import { Link } from 'react-router-dom';

import { Person } from '../../gs-core/common';

import './SubjectAndTitle.css';
import { PersonTitle, SubjectSearch, SubjectTypeSelector } from '../../Subject';
import { TitleSearch } from '../../TitleSearch/TitleSearch';
import { ActionTypes, Doc, Subject } from '../../common/models';
import { ServiceRegistry, SubjectSelection } from '../../services';

interface SubjectAndTitleProps {
  doc: Doc;
  editing: boolean;
  onSelectSubject: (subject?: Subject) => void;
  onSelectTitle: (title: string) => void;
}

interface SubjectAndTitleState {
  subjectSelection?: SubjectSelection;
}

export class SubjectAndTitle extends React.Component<SubjectAndTitleProps, SubjectAndTitleState> {
  static contextTypes = { services: PropObject };

  private searchComponent: SubjectSearch | null = null;
  private titleComponent: TitleSearch | null = null;

  onSelectSubject = (subject?: Subject) => {
    this.props.onSelectSubject(subject);

    if (this.titleComponent) {
      this.titleComponent.focus();
    }
  };

  onClearSubject = () => {
    this.props.onSelectSubject();

    window.setTimeout(
      () => {
        if (this.searchComponent) {
          this.searchComponent.focus();
        }
      },
      100
    );
  };

  constructor(props: SubjectAndTitleProps) {
    super(props);
    this.state = {};
  }

  async componentDidUpdate(prevProps: SubjectAndTitleProps) {
    const prevSubjectId = prevProps.doc.subject && prevProps.doc.subject.user.id;
    const prevSubjectType = prevProps.doc.subject && prevProps.doc.subject.type;
    const newSubjectId = this.props.doc.subject && this.props.doc.subject.user.id;
    const newSubjectType = this.props.doc.subject && this.props.doc.subject.type;

    if (prevSubjectId !== newSubjectId || prevSubjectType !== newSubjectType) {
      await this.loadSelection();
    }
  }

  async componentDidMount() {
    await this.loadSelection();
  }

  loadSelection = async () => {
    const { errorLogger, subjectService } = this.context.services as ServiceRegistry;

    try {
      const subject = this.props.doc.subject;
      const subjectSelection = subject ?
        await subjectService.findSelection(subject.user.id as number, subject.type) :
        undefined;
      this.setState({ subjectSelection });
    } catch (err) {
      await errorLogger.log(err);
    }
  };

  render() {
    const { subjectSelection } = this.state;
    const showSubjectType = subjectSelection && subjectSelection.allSubjects.length > 1;
    const { doc, editing, onSelectTitle } = this.props;
    const { subject, title, owningUnit } = doc;
    const user = subject && subject.user as Person;
    const altName = user && user.firstNamePreferred && user.firstNamePreferred !== user.firstName ? user.firstName : '';
    const subjectName = user && `${user.name}${ altName ? ' ( ' + altName + ' )' : ''}`;

    return (
      <div className="SubjectAndTitle">
        {editing && !subject ?
          <SubjectSearch
            className="SubjectAndTitle__subject"
            autoFocus={!subject}
            subject={subject}
            onSelect={this.onSelectSubject}
            action={ActionTypes.ASSIGN}
            ref={(component) => this.searchComponent = component}
          /> :
          subject &&
            <div className="SubjectAndTitle__subject form-control-static">
              <h3>
                {editing && <button onClick={this.onClearSubject} className="close">&times;</button>}
                <Link to={subject.getRoute()}> {subjectName}</Link>{' '}
                <small>( {subject.getIdentifier()} )</small>
              </h3>
              <PersonTitle person={subject.user as Person}/>
            </div>
        }
        {editing && subjectSelection && showSubjectType &&
          <div className="SubjectAndTitle__type">
            <SubjectTypeSelector subjectSelection={subjectSelection} onChange={this.onSelectSubject}/>
          </div>
        }
        <div className="SubjectAndTitle__title">
          {editing ?
            <TitleSearch
              autoFocus={!!subject && !title}
              title={title}
              onTextChange={onSelectTitle}
              unit={owningUnit}
              ref={(component) => this.titleComponent = component}
            /> :
           <h4 className="form-control-static">{title}</h4>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DocView/SubjectAndTitle/SubjectAndTitle.tsx